<template>
  <section class="section">
    <div class="container">
      <h1 class="title is-size-1" :aria-label="$t('about.title')">{{ $t('about.title') }}</h1>
      <hr>
      <div class="content is-medium">
	<template v-for="section, index in $t('about.sections')">
	  <h2 :aria-label="section.title">{{ section.title }}</h2>
	  <p v-for="(content, index) in section.content" :aria-label="content" v-html="content">
	    <!-- {{ content }} -->
	  </p>
	</template>
      </div>
    </div>
  </section>
</template>

<script>
 export default {
   layout: 'content'
 }
</script>
